import React, { useState, useCallback, useRef, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useModal } from 'react-modal-hook'
import { Formik, Form } from 'formik'
import './Auth.css'
import 'react-simple-keyboard/build/css/index.css'
import KeyboardModal from '../../components/Modal/KeyboardModal'
import Modal from '../../components/Modal/Modal'
import { LoginSchema } from '../../schemas/auth'
import InputError from '../../components/InputError/InputError'
import NeoInput from '../../components/NeoInput/NeoInput'
import NeoButton from '../../components/NeoButton/NeoButton'
import AuthLayout from './auth-layout'
import Loading from 'custom/assets/loaders/Loading'
import LoginMobile from 'custom/assets/landing/login-mobile.svg'
import BtnAppleStore from 'custom/assets/landing/btnAppleStore.svg'
import BtnGooglePlay from 'custom/assets/landing/btnGooglePlay.svg'
import AuthService from '../../services/auth.service'
import { useDispatch } from 'react-redux'
import { useErrorHandler } from 'react-error-boundary'
import {
  setCompanyDetails,
  setLoginDetails,
  setMenuDetails,
  setRoleAccessDetails,
  setRoleAccessKey,
  setUserDetails,
} from '../../store/actions/app.actions'
import { getProfileImage, getUserDetails } from '../../services/auth.service'
import NotificationService from '../../services/notification.service'
import { LOGIN_KEYS, BUTTON_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import validationConfig from 'custom/config/validation.config.json'
import menuData from 'custom/config/feature.config.json'
import { setMenuList } from '../../store/actions/app.actions'
const loginConfig = validationConfig['login']

export default function Login() {
  const handleError = useErrorHandler()
  const history = useHistory()
  const dispatch = useDispatch()
  const [error, setError] = useState('Error Placeholder')
  const [password, setPassword] = useState('')
  const [username, setUserName] = useState('')
  const [focusVal, setFocusVal] = useState('')
  const loginForm = useRef(null)
  const [clearKeyboard, setClearKeyboard] = useState(false)
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6 className='text-center'>{error}</h6>
          {/* {error?.error || 'Something went wrong.Please contact bank!'} */}
          <div className='modal-btn-style'>
            <NeoButton
              tabIndex='1'
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
                history.push('/login')
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [error],
  )

  const [showKeyboardModal, hideKeyboardModal] = useModal(
    () => (
      <KeyboardModal
        setText={setPasswordFieldValue}
        clearText={clearKeyboard}
        closeModel={hideKeyboardModal}>
        {focusVal === 'password' ? (
          <input
            className='form-control'
            disabled
            value={password}
            type='text'
            placeholder={t(LOGIN_KEYS.ENTER_PASSWORD)}
          />
        ) : (
          <input
            className='form-control'
            disabled
            value={username}
            type='text'
            placeholder={t(LOGIN_KEYS.ENTER_USERNAME)}
          />
        )}
        <div className='row d-flex'>
          <button
            type='button'
            className='mt-4 col-4 my-3 mx-auto btn neo-btn-new-design new-design'
            mode='newDesign'
            onClick={hideKeyboardModal}>
            {t(BUTTON_KEYS.SUBMIT)}
          </button>
          <button
            type='button'
            className='mt-4 col-4 my-3 mx-auto btn btn-sm btn-link small new-design-warning-text-color font-weight-600'
            onClick={() => {
              setClearKeyboard(true)
              setPasswordFieldValue('')
            }}>
            {t(BUTTON_KEYS.CLEAR)}
          </button>
        </div>
      </KeyboardModal>
    ),
    [password, clearKeyboard, focusVal, username],
  )

  const onSubmit = useCallback(async (values, { resetForm }) => {
    try {
      setLoading(true)
      const response = await AuthService.postLogin(values)

      if (response.status === 200) {
        dispatch(setLoginDetails(response.data))
        dispatch(setMenuList(menuData))
        if (response.data['otpEnable']) {
          history.push('/verify')
          return
        }
        const response1 = await AuthService.verifyLoginOTP({ otp: '0000' })
        if (response1.status === 200) {
          await getAllMenus(values)
          await getRights(values)
          //getUserDetails()
          getProfileImage()
          setLoading(false)
        }
      }
    } catch (err) {
      setLoading(false)
      resetForm({})
      // handleError(err.data)
    }
  }, [])

  const getAllMenus = useCallback(async (values) => {
    try {
      const response = await AuthService.getAllMenus(values)
      if (response.status === 200) {
        dispatch(setMenuDetails(response.data['menus']))
      }
    } catch (err) {
      console.error(err)
    }
  }, [])

  const getRights = useCallback(async (values) => {
    try {
      const response = await AuthService.getRights(values)
      if (response.status === 200) {
        const accessKeys = Object.keys(response.data['acccessList'])
        dispatch(setRoleAccessKey(accessKeys[0]))
        dispatch(setUserDetails(response.data['user']))
        dispatch(setRoleAccessDetails(response.data['acccessList']))
        dispatch(setCompanyDetails(response.data['company']))

        if (response.data['user'].newPwdFlg === 'Y') {
          history.push('/resetPassword')
          return
        }
        history.push('/dashboard')
      }
    } catch (err) {
      console.error(err)
    }
  }, [])

  const setPasswordFieldValue = useCallback(
    (value) => {
      if (focusVal === 'password') {
        setPassword(value)
        loginForm.current('password', value)
      } else {
        setUserName(value)
        loginForm.current('username', value)
      }
    },
    [loginForm, focusVal],
  )

  const setFocusItem = useCallback((value) => {
    console.log(value.target.name)
    setFocusVal(value.target.name)
  }, [])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='45px' height='45px' />
      </div>
    )
  }

  return (
    <AuthLayout>
      <h2 className='app-name'>{t(LOGIN_KEYS.APP_NAME)}</h2>
      <div className='text-center'>
        <img
          className=''
          style={{ margin: '0 auto' }}
          src={LoginMobile}
          alt='mobile logo'
          height='100'
        />
      </div>
      <div className='mx-auto' style={{ width: 320 }}>
        <Formik
          initialValues={{ username: '', password: '' }}
          validationSchema={LoginSchema}
          onSubmit={onSubmit}>
          {({ isSubmitting, errors, values, touched, handleChange, setFieldValue }) => {
            if (loginForm.current === null) {
              loginForm.current = setFieldValue
            }
            return (
              <Form>
                <NeoInput
                  tabIndex={'1'}
                  showAsterisk={loginConfig['isUserNameRequired']}
                  name='username'
                  text={t(LOGIN_KEYS.USERNAME)}
                  icon='person'
                  mode='icon'
                  disabled={isSubmitting}
                  onFocus={setFocusItem}
                  value={values.username}
                  onChange={handleChange}
                  placeholder={t(LOGIN_KEYS.USERNAME)}
                />
                <InputError text={errors.username} touched={touched.username} />
                <div className='my-3' />
                <div className='form-group'>
                  <NeoInput
                    tabIndex={'2'}
                    showAsterisk={loginConfig['isPasswordRequired']}
                    name='password'
                    text={t(LOGIN_KEYS.PASSWORD)}
                    icon='lock'
                    mode='sensitiveIcon'
                    onFocus={setFocusItem}
                    disabled={isSubmitting}
                    placeholder={t(LOGIN_KEYS.PASSWORD)}
                    onChange={handleChange}
                    value={values.password}
                  />
                  <InputError text={errors.password} touched={touched.password} />
                </div>
                <div className='my-3' />
                <div className='row'>
                  <div className='col-3'>
                    <div
                      className={focusVal == '' ? 'disabled' : 'cursor-pointer'}
                      onClick={showKeyboardModal}>
                      <i className='material-icons h2'>keyboard</i>
                    </div>
                  </div>

                  {menuData['isForgotPswd'] && (
                    <div className='text-right col-9'>
                      <button 
                        tabIndex={'3'}
                        type='button'
                        onClick={() => history.push('/forgot-password')}
                        className='btn btn-sm btn-link small new-design-warning-text-color font-weight-600'>
                        {t(LOGIN_KEYS.FORGOT_PASSWORD)}
                      </button>
                    </div>
                  )}
                </div>
                <div className='my-3' />
                {loading === false ? (
                  <NeoButton
                    tabIndex={'4'}
                    type='submit'
                    mode='newDesign'
                    text={t(BUTTON_KEYS.LOGIN)}
                    styles={{ fontSize: 16, width: '312px' }}
                  />
                ) : null}
                {loading === true ? renderLoading() : null}
              </Form>
            )
          }}
        </Formik>
      </div>

      <div className='d-flex justify-content-center' style={{ marginTop: 50 }}>
        {menuData['appStore'] && (
          <button  tabIndex={'5'} type='button' className='btn btn-apple-store'>
            <img className='' src={BtnAppleStore} alt='Apple Store button' />
          </button>
        )}
        {menuData['playStore'] && (
          <button  tabIndex={'6'} type='button' className='btn btn-play-store'>
            <img className='' src={BtnGooglePlay} alt='Play Store button' />
          </button>
        )}
      </div>
    </AuthLayout>
  )
}
